import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from '../redux/action-creators';
import SessionLoading from './session-loading';

const AuthInitializer = ({ children }) => {
  const token = useSelector((state) => state.token);
  const dispatch = useDispatch();
  const [verified, setVerified] = useState(!token);

  useEffect(() => {
    if (!token) return;
    // Reuse the same getUserInfo thunk that the rest of the app uses
    // (login, page-level data refreshes) so any future change to its
    // request shape, error handling, or retry behavior automatically
    // applies here too. error-middleware handles logout/redirect on
    // auth failure, so we only need to flip `verified` once the round
    // trip resolves.
    dispatch(getUserInfo(token)).finally(() => {
      setVerified(true);
    });
    // run once on mount with the rehydrated token
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!verified) return <SessionLoading />;
  return children;
};

export default AuthInitializer;
